import { normalizeName } from "services/utils";

export class Config {

  static userPoolId = "USER_POOL_ID";
  static userPoolClientId = "USER_POOL_CLIENT_ID";
  static oAuthDomain = "OAUTH_DOMAIN";
  static redirectSignIn = "REDIRECT_SIGN_IN";
  static redirectSignOut = "REDIRECT_SIGN_OUT";
  static stripeApiKey = "STRIPE_API_KEY";
  static baseUrl = "URL"
  static s3FilePattern = "{country}/{name}_{numbers}.json";
  static appendDomain = (path) => {
    return process.env.REACT_APP_API_BASE_URL + "/" + path;
  }

  static appendS3Domain = (path) => {
    return process.env.REACT_APP_S3_BASE_URL + "/" + path;
  }

  static getPublicFileUrl = (filePath = "") => {
    const normalizedFilePath = String(filePath || "").replace(/^\/+/, "");
    return Config.appendS3Domain(normalizedFilePath);
  }

  static getProperty = (property_name) => {
    const react_property_name = `REACT_APP_${property_name}`;
    return process.env[react_property_name];
  }

  static getS3Url = (gameRules, numbers) => {
    const country = gameRules.storageCountry || gameRules.country;
    const name = gameRules.backendKey || gameRules.id || gameRules.name;
    return Config.appendS3Domain(
      this.s3FilePattern
        .replace("{country}", normalizeName(country))
        .replace("{name}", normalizeName(name))
        .replace("{numbers}", numbers)
    );
  }

  static getPrivateFilesUrl = (gameName, limit) => {
    return Config.appendDomain(`private-files/${gameName}/${limit}`);
  }

  static getReportUrl = () => {
    return Config.appendDomain("reports")
  }

  static getGamesUrl = (gameName, selectedLimit) => {
    return Config.appendDomain("games") + `/${gameName}?limit=${selectedLimit || 0}`;
  }

  static getTicksUrl = () => {
    return Config.appendDomain("ticks")
  }

  static getUsersUrl = () => {
    return Config.appendDomain("users")
  }

  static getSubscriptionsUrl = () => {
    return Config.appendDomain("subscriptions")
  }

  static createCheckoutSessionUrl = () => {
    return Config.appendDomain("payments/sessions")
  }

  static createBillingPortalSessionUrl = () => {
    return Config.appendDomain("billing/portal-session")
  }

  static getCheckoutSessionStatusUrl = () => {
    return Config.appendDomain("billing/checkout-session");
  }

  static receiptsUrl = (sessionId) => {
    return Config.appendDomain(`payments/sessions/${sessionId}/receipts`)
  }

  static paymentsUrl = () => {
    return Config.appendDomain(`payments`)
  }

  static getPricingContextUrl = () => {
    return Config.appendDomain("pricing-context");
  }

  static getLocationContextUrl = () => {
    return Config.appendDomain("location-context");
  }

  static getUserPoolId() {
    return Config.getProperty(this.userPoolId)
  }

  static getUserPoolClientId() {
    return Config.getProperty(this.userPoolClientId)
  }

  static getOauthDomin() {
    return Config.getProperty(this.oAuthDomain)
  }

  static getRedirectSignIn() {
    return Config.getProperty(this.redirectSignIn)
  }

  static getRedirectSignOut() {
    return Config.getProperty(this.redirectSignOut)
  }

  static getStripeApiKey() {
    return Config.getProperty(this.stripeApiKey)
  }

  static getBaseUrl() {
    return Config.getProperty(this.baseUrl)
  }

}
